import { useState } from 'react';
import Navbar from '@/pages/home/components/Navbar';
import Hero from '@/pages/home/components/Hero';
import CategoryNav from '@/pages/home/components/CategoryNav';
import TopicBoard from '@/pages/home/components/TopicBoard';
import FeaturedCards from '@/pages/home/components/FeaturedCards';
import TagDirectory from '@/pages/home/components/TagDirectory';
import TrustFaq from '@/pages/home/components/TrustFaq';
import UpdateBoard from '@/pages/home/components/UpdateBoard';
import CtaBand from '@/pages/home/components/CtaBand';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  const [query, setQuery] = useState('');

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero query={query} onQueryChange={setQuery} />
        <CategoryNav query={query} />
        <TopicBoard />
        <FeaturedCards />
        <TagDirectory query={query} />
        <TrustFaq />
        <UpdateBoard />
        <CtaBand />
      </main>
      <Footer />
    </div>
  );
}